import {chatConversationsContract} from './chatConversations';
import {chatAttachmentsContract} from './chatAttachments';
import {initContract} from '@ts-rest/core';
import {knowledgeBasesContract} from './knowledgeBases';
import {sourcesContract} from './sources';
import {tenantsContract} from './tenants';
import {uploadContract} from './upload';
import {rolesContract} from './roles';
import {usersContract} from './users';
import {roleTypesContract} from './roleTypes';
import {invitesContract} from './invites';
import {assistantsContract} from './assistants';
import {appConfigsContract} from './appConfigs';
import {tokenUsageContract} from './tokenUsage';
import {toolsContract} from './tools';
import {tenantMcpServersContract} from './tenantMcpServers';
export {chatCompletionContract} from './chatCompletion';
export {chatConversationsContract} from './chatConversations';
export {
  chatAttachmentsContract,
  ALLOWED_IMAGE_MIME_TYPES,
  ALLOWED_DOCUMENT_MIME_TYPES,
  ALLOWED_MIME_TYPES,
  MAX_IMAGE_BYTES,
  MAX_DOCUMENT_BYTES,
  MAX_ATTACHMENTS_PER_MESSAGE,
  type ChatAttachmentResponse
} from './chatAttachments';
export {knowledgeBasesContract} from './knowledgeBases';
export {sourcesContract} from './sources';
export {tenantsContract} from './tenants';
export {uploadContract} from './upload';
export {rolesContract} from './roles';
export {usersContract} from './users';
export {roleTypesContract} from './roleTypes';
export {invitesContract} from './invites';
export {assistantsContract} from './assistants';
export {appConfigsContract} from './appConfigs';
export {tokenUsageContract} from './tokenUsage';
export {toolsContract, toolCatalogEntrySchema, type ToolCatalogEntry} from './tools';
export {tenantMcpServersContract, discoveredMcpToolSchema} from './tenantMcpServers';
export {chatSourceSchema, type ChatSource} from '../utils/chatSources';

const c = initContract();

export const apiContract = c.router({
  knowledgeBases: knowledgeBasesContract,
  upload: uploadContract,
  sources: sourcesContract,
  tenants: tenantsContract,
  roles: rolesContract,
  roleTypes: roleTypesContract,
  chatConversations: chatConversationsContract,
  chatAttachments: chatAttachmentsContract,
  users: usersContract,
  invites: invitesContract,
  assistants: assistantsContract,
  appConfigs: appConfigsContract,
  tokenUsage: tokenUsageContract,
  tools: toolsContract,
  tenantMcpServers: tenantMcpServersContract
});
